import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const Work: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['remuneration']});
	return (
		<LandingIllustrationSection
			description={
				<>
					<Image
						priority
						aspectRatio="516/363"
						maxW={{base: '285px'}}
						sizes="50vw"
						src="c534c3c103bbd48ef8c5d7404833de5c.png"
						alt="fraud"
					/>
					<LandingHeading as="h2" maxWidth="550px">
						{t(
							'acpslandingpage_title_moresupportforrealartists_standalone-web',
						)}
					</LandingHeading>
					<LandingParagraph
						maxWidth="550px"
						color="text.neutral.primary.default"
					>
						{t('acpslandingpage_text_moresupportforrealartists_standalone-web')}
					</LandingParagraph>
				</>
			}
		/>
	);
};
